import React from 'react';

const Footer = () => <footer>Footer</footer>;

export default Footer;
